import React from 'react';
import { IconSvgProps } from '@models/common';

const Unlock: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16 9V7C16 4.79086 14.2091 3 12 3C10.7368 3 9.61038 3.58554 8.87731 4.5M8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V12.2C19 11.0799 19 10.5198 18.782 10.092C18.5903 9.71569 18.2843 9.40973 17.908 9.21799C17.4802 9 16.9201 9 15.8 9H8.2C7.0799 9 6.51984 9 6.09202 9.21799C5.71569 9.40973 5.40973 9.71569 5.21799 10.092C5 10.5198 5 11.0799 5 12.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21Z'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
      />
      <circle
        cx='12'
        cy='15'
        r='1.5'
        fill='currentColor'
        stroke='currentColor'
      />
    </svg>
  );
};

export default Unlock;
